<template>
  <!-- 直通乡镇 -->
  <div class="ztxz" :style="{ color }">
    <div class="top_title" :style="{ color, borderColor: borderBottomColor }">
      <div style="display: flex;justify-content: center;align-items: center;">
        <img style="margin-right:5px;" :src="imgSrc" alt="" srcset="">
        <span>直通乡镇</span>
      </div>
    </div>
    <div class="xzlist" :style="{ borderColor: boxBorderColor }">
      <!-- <a href="javascript">县本级</a> -->
      <!-- <a href="javascript">富林镇</a> -->
      <router-link :to="{ name: item.url, params: { mapIds: item.hanyuanMaps } }" v-for="item in villages"
        :key="item.mapId">{{ item.name }}</router-link>
      <!-- <a href="javascript">乌斯河镇</a>
      <a href="javascript">宜东镇</a>
      <a href="javascript">富庄镇</a>
      <a href="javascript">清溪镇</a>
      <a href="javascript">大树镇</a>
      <a href="javascript">皇木镇</a>
      <a href="javascript">唐家镇</a>
      <a href="javascript">富泉镇</a>
      <a href="javascript">顺河乡</a>
      <a href="javascript">前域镇</a>
      <a href="javascript">富乡乡</a>
      <router-link to="/CharacteristicVillage/AnLe">安乐镇</router-link>
      <a href="javascript">马烈乡</a>
      <a href="javascript">河南乡</a>
      <a href="javascript">小堡乡</a>
      <a href="javascript">片马乡</a>
      <a href="javascript">坭美乡</a>
      <a href="javascript">永利彝族乡</a>
      <a href="javascript">顺河乡</a> -->
    </div>
  </div>
</template>
<script>
import { getVillages, unauthorized } from "@/api/map/index";
export default {
  name: 'ztxzList',
  props: {
    imgSrc: '',
    color: '',
    borderBottomColor: '',
    boxBorderColor: '',  //div 边框颜色
    villages: [],  //乡镇列表
  },
  data() {
    return {
      // villages: [],  //乡镇列表
    };
  },

  mounted() {
    // this.GetVillages()
  },

  methods: {
    GetVillages() {
      let obj={method:'/zwmap/getVillages', body: ''}
      // getVillages().then(res => {
      unauthorized(obj).then( res => {
        // console.log(res, '乡镇列表')
        if (res.status == 200) {
          if (res.data.data && res.data.data.length > 0) {
            let arrList = res.data.data;
            arrList.unshift({type: null, mapId: "fa08802c1d4d11eda7660242ac120002", name: "县本级"});
            for (let index = 0; index < arrList.length; index++) {
              switch (arrList[index].name.slice(0, 2)) {
                case '县本':
                  arrList[index].url = 'HanYuan'
                  break;
                case '安乐':
                  arrList[index].url = 'AnLe'
                  break;
                case '大树':
                  arrList[index].url = 'DaShu'
                  break;
                case '富林':
                  arrList[index].url = 'FuLin'
                  break;
                case '富泉':
                  arrList[index].url = 'FuQuan'
                  break;
                case '富乡':
                  arrList[index].url = 'FuXiang'
                  break;
                case '富庄':
                  arrList[index].url = 'FuZhuang'
                  break;
                case '河南':
                  arrList[index].url = 'HeNan'
                  break;
                case '皇木':
                  arrList[index].url = 'HuangMu'
                  break;
                case '九襄':
                  arrList[index].url = 'JiuXiang'
                  break;
                case '马烈':
                  arrList[index].url = 'MaLie'
                  break;
                case '坭美':
                  arrList[index].url = 'NiMei'
                  break;
                case '片马':
                  arrList[index].url = 'PianMa'
                  break;
                case '前域':
                  arrList[index].url = 'QianYu'
                  break;
                case '清溪':
                  arrList[index].url = 'QingXi'
                  break;
                case '晒经':
                  arrList[index].url = 'ShaiJin'
                  break;
                case '顺河':
                  arrList[index].url = 'ShunHe'
                  break;
                case '唐家':
                  arrList[index].url = 'TangJia'
                  break;
                case '乌斯':
                  arrList[index].url = 'WuSiHe'
                  break;
                case '小堡':
                  arrList[index].url = 'XiaoBao'
                  break;
                case '富泉':
                  arrList[index].url = 'FuQuan'
                  break;
                case '宜东':
                  arrList[index].url = 'YiDong'
                  break;
                case '永利':
                  arrList[index].url = 'YongLi'
                  break;
                default:
                  break;
              }
            }
            // console.log(arrList,'结果')
            this.villages = arrList;
          }
        } else {
          this.$message.error('获取乡镇列表失败！')
        }
      })
    }
  },
};
</script>
<style scoped>
.top_title {
  color: #DC7312;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #EBA970;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
  border-radius: 10px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>